import { useEffect } from 'react';
import { useSelector } from 'react-redux';

const useWizard = () => {
  const { show } = useSelector((state) => state.onboarding);

  useEffect(() => {
    const loader = document.getElementById('mobile-preload-container');
    let checkWizardTimeout;
    let finishAnimationTimeout;
    let waitForWizardTimeout;

    waitForWizardTimeout = setTimeout(() => {
      // enable wizard to be always shown on dev mode
      if (import.meta.env.MODE === 'development') {
        window.showWizard();
      }
      if (!show) {
        checkWizardTimeout = setTimeout(() => {
          if (loader) {
            loader.classList.add('hide-preload');
          }

          finishAnimationTimeout = setTimeout(() => {
            if (loader) {
              loader.remove();
            }
          }, 1000);
        }, 100);
      }
    }, 2000)

    return () => {
      clearTimeout(checkWizardTimeout);
      clearTimeout(finishAnimationTimeout);
      clearTimeout(waitForWizardTimeout);
    }
  }, [show]);
}

export default useWizard;
